import { GoalId } from './quiz';

export const audioSampleIds = [
  'news',
  'history',
  'business',
  'medicine',
  'physics',
  'darkRomance',
  'environment',
  'fanfiction',
  'fantasy',
  'finance',
  'fitness',
  'marketing',
  'mentalHealth',
  'parenting',
  'personalGrowth',
  'religion',
  'romance',
  'science',
  'thrillerMystery',
  'wealthBuilding',
  'wellBeing',
  'math',
  'literature',
  'cs',
  'law',
  'economics',
  'politics',
  'biology',
  'arts',
] as const;

export type AudioSampleId = (typeof audioSampleIds)[number];

export const goalsAudioIdsMap = {
  beMoreProductive: ['personalGrowth'],
  learnSomethingNew: ['history', 'science'],
  listenOnTheGo: ['business', 'news'],
  makeReadingEasier: ['literature', 'thrillerMystery'],
  everythingIsPerfect: ['history', 'personalGrowth'],
  adhdEyeStrainDyslexia: ['medicine', 'fitness'],
} as const satisfies Record<GoalId, readonly AudioSampleId[]>;
